export const TAGLINE =
  "Save the land of Codia and restore the sacred Mainline with the help of three mythical creatures and their gifts.";

export const INTRO_NARRATION = [
  "You're the lead developer in a magical place called Codia, where everything normally runs smoothly on the main branch.",
  "But something's gone wrong. A glitch in version control has caused everything to split into unstable branches, and now people are stuck with detached HEADs. Fixes aren't holding, and things are starting to break down fast.",
  "The engineering team checked with the top experts and figured out the only way to fix things: find three key resources that can help restore everything back to normal.",
];

export const VICTORY_NARRATION = [
  "Remember my adventurer friend, the fate of Codia is in your hands.",
  "Save the land and restore the sacred Mainline with the help of three mythical creatures and their gifts.",
];

export const MENTOR_DIALOG = {
  mona: [
    "Mona: The branches have grown wild and tangled, friend.",
    "Take this — the Fork of Curiosity. May it help you split a path where there was only one.",
  ],
  ducky: [
    "Ducky: The river of changes is frozen in confusion.",
    "Carry these Bubbles of Clarity. They will lift the fog from any blocker in your way.",
  ],
  copilot: [
    "Copilot: The Sacred Tree's higher boughs lie hidden from sight.",
    "Wear the Goggles of Insight — what was unseen will guide your next leap.",
  ],
};

export const LEVEL_INTROS = {
  mona: "The Forest Archives — where commits go to be remembered.",
  ducky: "The Frozen River — where stuck pipelines weep.",
  copilot: "The Sky of the Sacred Tree — where insight is earned, not given.",
  boss: "The Mainline Corruption — the source of every detached HEAD.",
};
